<div class="dialog-content-wrapper">
    <mat-toolbar class="mat-primary m-0">
        <mat-toolbar-row
            fxFlex
            fxLayout="row"
            fxLayoutAlign="space-between center"
        >
            <span class="title dialog-title text-truncate">Especialidades</span>
            <button
                mat-icon-button
                (click)="dialogRef.close()"
                aria-label="Close dialog"
            >
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <mat-dialog-content class="p-16 pb-0 m-0">
        <mat-form-field class="full-width">
            <mat-label>Categorias</mat-label>
            <mat-select
                required
                (selectionChange)="buscarGruposCategoria($event)"
            >
                <mat-option
                    *ngFor="let categoria of data.categorias"
                    [value]="categoria.id"
                >
                    {{ categoria.descripcion }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field class="full-width">
            <mat-label>Grupos</mat-label>
            <mat-select [formControl]="grupos" multiple>
                <!-- mat-select-trigger>
                    {{ grupos.value ? grupos.value[0]?.descripcion : "" }}

                    <span
                        *ngIf="grupos.value?.length > 1"
                        class="example-additional-selection"
                    >
                        (+{{ grupos.value.length - 1 }}
                        {{ grupos.value?.length === 2 ? "comuna" : "comunas" }})
                    </span>
                </mat-select-trigger -->
                <mat-option *ngFor="let grupo of listaGrupos" [value]="grupo">{{
                    grupo.descripcion
                }}</mat-option>
            </mat-select>
        </mat-form-field>
    </mat-dialog-content>

    <mat-dialog-actions
        class="m-0 p-16"
        fxLayout="row"
        fxLayoutAlign="end center"
    >
        <button mat-button mat-dialog-close>Cancelar</button>
        <button
            mat-raised-button
            color="accent"
            (click)="guardar()"
            [disabled]="!grupos.value || grupos.value?.length === 0"
        >
            Guardar
        </button>
    </mat-dialog-actions>
</div>
